import * as CookieConsent from 'vanilla-cookieconsent';
import Splash from './components/splash';
import FrontDoor from './components/front-door';
import Radius from './components/adjustRadius';
import Tabs from './components/tabs';
import Modal from './components/modal';

const global = {
    init() {
        Splash.init();
        FrontDoor.init();
        Radius.init();
        Tabs.init();
        Modal.init();

        CookieConsent.run({

            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true  // this category cannot be disabled
                },
                analytics: {}
            },

            language: {
                default: 'es',
                translations: {
                    es: {
                        consentModal: {
                            title: "Configuración de cookies",
                            description: "Las cookies nos permiten ofrecerte una mejor experiencia, mejorar nuestros productos y reducir los costes de marketing. No las activaremos hasta que las aceptes.",
                            acceptAllBtn: "Aceptar todo",
                            acceptNecessaryBtn: "Rechazar todo",
                            showPreferencesBtn: "Gestionar preferencias",
                            footer: "<a href=\"https://codent.es/politica-de-privacidad.html\">Política de privacidad</a>\n<a href=\"https://codent.es/terminos-y-condiciones.html\">Términos y condiciones</a>"
                        },
                        preferencesModal: {
                            title: "Preferencias de Consentimiento",
                            acceptAllBtn: "Aceptar todo",
                            acceptNecessaryBtn: "Rechazar todo",
                            savePreferencesBtn: "Guardar preferencias",
                            closeIconLabel: "Cerrar modal",
                            serviceCounterLabel: "Servicios",
                            sections: [
                                {
                                    title: "Uso de Cookies",
                                    description: "Las cookies nos ayudan a mejorar tu experiencia, personalizar anuncios según tus intereses y optimizar nuestro sitio web.\nDescubre más sobre las diferentes categorías de cookies expandiendo cada una a continuación. Consulta nuestra <a class=\"cc__link\" href=\"https://codent.es/politica-de-cookies.html\">Política de Cookies</a> para obtener más información sobre cómo las usamos y cómo ajustar tus preferencias en cualquier momento."
                                },
                                {
                                    title: "Cookies Estrictamente Necesarias <span class=\"pm__badge\">Siempre Habilitado</span>",
                                    description: "Estas cookies permiten el acceso seguro a áreas protegidas del sitio web y garantizan sus funciones básicas, como la navegación. La web no puede funcionar correctamente sin estas cookies, por lo que no podrás activarlas ni desactivarlas.",
                                    linkedCategory: "necessary"
                                },
                                {
                                    title: "Cookies Analíticas",
                                    description: "Nos ayudan a comprender cómo los visitantes interactúan con nuestro sitio web (como las páginas que visitan y el tiempo que permanecen en ellas) recopilando y reportando información de manera anónima.",
                                    linkedCategory: "analytics"
                                },
                                {
                                    title: "Más información",
                                    description: "El usuario puede plantear cualquier consulta relacionada con el uso de cookies que no esté contestada en esta <a class=\"cc__link\" href=\"https://codent.es/politica-de-cookies.html\">Política de Cookies</a> a través del correo electrónico <a class=\"cc__link\" href=\"mailto:info@codent.es\">info@codent.es</a>."
                                }
                            ]
                        }
                    }
                }
            }
        });

    }
};

window.addEventListener('DOMContentLoaded', () => {
    global.init();
});